import { RadioProps } from "@bluframe/blublocks"
import { memo } from "react"

import Item from "./Item"

export interface Props {
  flagLoading: boolean
  id: string
  isFlagged: boolean
  isShowFlagButton: boolean
  label: string
  name: string
  onSelect: RadioProps["onChange"]
  onToggleFlagged: (id: string, isFlagged: boolean) => () => void
  selected: RadioProps["value"]
  url: string
}

export interface ComponentProps extends Props {}

export default memo(Item)
